import { create } from '@storybook/theming/create';
import { defaultTheme } from '../src/themes/defaultTheme';

export default create({
  base: 'light',
  colorPrimary: defaultTheme.palette.primary.main,
  colorSecondary: defaultTheme.palette.secondary.main,

  // UI
  appBg: defaultTheme.palette.common.white,
  appContentBg: defaultTheme.palette.background.default,
  // appBorderColor: color(colorMap.primary).darken(0.1).toHexString(),
  appBorderRadius: 4,

  // Text colors
  textColor: defaultTheme.palette.common.black,
  textInverseColor: defaultTheme.palette.common.white,

  // Toolbar default and active colors
  barTextColor: '#555555',
  barSelectedColor: defaultTheme.palette.primary.main,
  barBg: defaultTheme.palette.common.white,

  brandTitle: 'Up - Design',
  brandUrl: 'https://up.coop',
  brandImage: 'http://backoffice.up.coop/app/uploads/2018/09/up-logo.png',
});
